(() => {
  if (customElements.get('warranty-application')) return;
  customElements.define('warranty-application', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.fallback = this.querySelector('[data-form-fallback]');
      this.status = this.querySelector('[data-form-state]');
      this.retry = this.querySelector('[data-form-retry]');
      if (!this.status || !this.fallback) return;
      this.unavailable = this.status.textContent;
      this.status.textContent = this.status.dataset.loading;
      this.shadows = new Set();
      this.observer = new MutationObserver(() => this.inspectForm());
      this.observer.observe(this, {childList: true, subtree: true});
      this.controller = new AbortController();
      this.retry?.addEventListener('click', () => location.reload(), {signal: this.controller.signal});
      this.timeout = setTimeout(() => {
        if (!this.fallback.hidden) {
          this.status.textContent = this.unavailable;
          if (this.retry) this.retry.hidden = false;
        }
      }, 15000);
      this.inspectForm();
    }
    inspectForm() {
      for (const embed of this.querySelectorAll('shopify-forms-embed')) {
        const root = embed.shadowRoot;
        if (!root) continue;
        if (!this.shadows.has(root)) {
          this.shadows.add(root);
          this.observer.observe(root, {childList: true, subtree: true});
        }
        if (root.querySelector('form')) {
          this.fallback.hidden = true;
          clearTimeout(this.timeout);
          this.observer.disconnect();
          return;
        }
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      clearTimeout(this.timeout);
      this.ready = false;
    }
  });
})();
